import React, { useState, useEffect } from "react";
import ModalComponent from "../../../adminpanel/components/commonComponents/ModalComponent";
import FormMetricRange from "./FormMetricRange";

const modalConfig = {
  range_handle: {
    id: "rangeHandleModal",
    form_name: "rangeHandle",
    form_id: "rangeHandleForm",
    title: "Range Details",
    body: null,
    button_name: "Apply",
    buttonType: "submit",
    display: true,
    height: "500"
  },
};


const RangeMetricComponent = ({ eventType, allPropsData, setMetricRange, eventChange, metricRange }) => {
  const [rangeDetails, setRangeDetails] = useState(null);
  let dataStored = {};
  let displayModal = null;
  if (refineURLData(metricRange)) {
    let dataMetric = metricRange.split(",");
    dataMetric.map((ele) => {
      let item = ele.split(":");
      let value = item[0];
      dataStored[value] = { "min": item[1], "max": item[2] }
    })
  }

  useEffect(() => {
    getFormData();
    if (eventType) {
      setTimeout(() => {
        jQuery("#rangeHandleModal").modal("toggle");
      }, 5);
    }
  }, [eventType]);

  const getFormData = (renderType = "default", data, name = "") => {
    let rangeConfig = [];
    if (renderType == "range") {
      rangeDetails.map((ele) => {
        if (ele.saveValue === name) {
          rangeConfig.push({
            metricLabel: ele.metricLabel,
            metricValue: ele.metricValue,
            rangeId: ele.rangeId,
            inputFromId: ele.inputFromId,
            inputToId: ele.inputToId,
            saveValue: ele.saveValue,
            setMin: data.from,
            setMax: data.to,
            checkBoxValue: ele.checkBoxValue,
          });
        } else {
          rangeConfig.push(ele);
        }
      });
    } else {
      let baseUrlMetric = getParameters("metricRange");
      allPropsData.metricDisp.map((ele) => {
        let metricVal = ele.value.split(";");
        rangeConfig.push({
          metricLabel: ele.label,
          metricValue: metricVal[0],
          rangeId: `${metricVal[0]}_${metricVal[1]}_rangeslider`,
          inputFromId: `${metricVal[0]}_${metricVal[1]}_rangeslider_from`,
          inputToId: `${metricVal[0]}_${metricVal[1]}_rangeslider_to`,
          saveValue: ele.value,
          setMin: metricRange ? (dataStored.hasOwnProperty(ele.value) ? dataStored[ele.value]["min"] : minMaxDataGlobal[ele['value']].min) : minMaxDataGlobal[ele['value']].min,
          setMax: metricRange ? (dataStored.hasOwnProperty(ele.value) ? dataStored[ele.value]["max"] : minMaxDataGlobal[ele['value']].max) : minMaxDataGlobal[ele['value']].max,
          checkBoxValue: baseUrlMetric !== undefined && baseUrlMetric.includes(ele.value)
            ? true
            : baseUrlMetric !== undefined && baseUrlMetric.includes(ele.value) === false 
              ? false
              : baseUrlMetric === undefined 
                ? true
                : true
        });
      });
    }
    setRangeDetails(rangeConfig);
  };

  const action = (event) => {
    let finalRange = ""
    let finalOp = [];

    setTimeout(() => {
      jQuery("#rangeHandleModal").modal("toggle");
      eventChange(null);
    }, 5);

    rangeDetails.map((ele) => {
      if (ele.checkBoxValue === true) {
        let instance = $(`#${ele.rangeId}`).data("ionRangeSlider");
        finalOp.push({
          value: ele.saveValue,
          min: instance.old_from,
          max: instance.old_to
        });
        finalRange += `${ele.saveValue}:${instance.old_from}:${instance.old_to},`
      }
    });

    finalRange = finalRange.substring(0, finalRange.length - 1);
    let currentUrl = window.location.search + `&metricRange=${finalRange}`
    let urlObj = Object.fromEntries(new URLSearchParams(currentUrl));
    updateURL(urlObj, '', true)
    setMetricRange({ metricRange: finalRange });
    event.preventDefault();
  };

  modalConfig["range_handle"]["body"] = rangeDetails
    ? <FormMetricRange
      rangeDetails={rangeDetails}
      formDataHandle={getFormData}
      setRangeDetails={setRangeDetails}
    />
    : null
  modalConfig["range_handle"]["formKey"] = `range_handle_${Math.floor(Math.random() * 10)}`;
  if (modalConfig["range_handle"]["body"]) {
    displayModal = (
      <ModalComponent modalConfig={modalConfig["range_handle"]} action={action} cancelEvent={eventChange} />
    );
  }

  return displayModal;
};

export default RangeMetricComponent;